import React from "react";
import { styled } from "@mui/system";
import MUIButtonGroup from "@mui/material/ButtonGroup";
import { ButtonGroupProps as ButtonGroupPropsMUI } from "@mui/material/ButtonGroup";
export interface ButtonGroupProps extends ButtonGroupPropsMUI {
  component?: React.ElementType;
}

export const ButtonGroup: (props: ButtonGroupProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, ButtonGroupProps>((props, ref) => (
    <MUIButtonGroup ref={ref} {...props} />
  )),
  {
    name: "ButtonGroup",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiButtonGroup-root": {
    borderRadius: 20,
    boxShadow: "none"
  },
  "&.MuiButtonGroup-root .MuiButton-root.MuiButton-contained": {
    minWidth: 48,
    height: 40,
    background: theme.palette.primary.background,
    color: theme.palette.primary.textSubduedColor,
    textShadow: "none",
    fontSize: 14,
    ":hover": {
      background: theme.palette.primary.interactiveSelectedColor,
      color: theme.palette.primary.textTitleColor
    },
    ":first-of-type": {
      borderRadius: "20px 0px 0px 20px",
      height: 40,
      background: theme.palette.primary.background,
      color: theme.palette.primary.textSubduedColor,
      textShadow: "none",
      fontSize: 14,
      ":hover": {
        background: theme.palette.primary.interactiveSelectedColor,
        color: theme.palette.primary.textTitleColor
      }
    },
    ":last-child": {
      borderRadius: "0px 20px 20px 0px"
    },
    ":not(:last-child)": {
      border: "none"
    }
  },
  "&.MuiButtonGroup-root .MuiButton-root.MuiButton-outlined": {
    minWidth: 48,
    border: "1px solid " + theme.palette.primary.borderActive,
    background: theme.palette.primary.interactiveSelectedColor,
    color: theme.palette.primary.textTitleColor,
    fontSize: 14,
    ":first-of-type": {
      borderRadius: "20px 0px 0px 20px"
    },
    ":last-child": {
      borderRadius: "0px 20px 20px 0px"
    }
  },
  "&.MuiButtonGroup-root .MuiButton-root svg": {
    width: 32,
    height: 14
  }
}));
